import { css } from "styled-components";

export const svgToDataURL = (svgStr: string) => {
  const encoded = encodeURIComponent(svgStr)
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");

  const header = "data:image/svg+xml,";
  const dataUrl = header + encoded;

  return dataUrl;
};

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
`;

export const focusRing = css`
  box-shadow: 0 0 0 1px
      ${({ theme }) => theme.colors.button.primary.background.base},
    0 0px 0px 4px
      color-mix(
        in srgb,
        ${({ theme }) => theme.colors.button.primary.background.base},
        transparent 70%
      );
  outline: none;

  &::-moz-focus-inner {
    border: 0;
  }
`;

export const pill = css`
  min-width: ${({ theme }) => theme.space[600]};
  min-height: ${({ theme }) => theme.space[600]};
  padding: ${({ theme }) => theme.space[300]};
  border-radius: ${({ theme }) => theme.radii.pill};
`;

/**
 * General-purpose disabled mixin. Applies opacity and removes pointer events.
 *
 * NOTE: Do NOT use this mixin for interactive elements. Those elements must
 * remain pointer-accessible.
 */
export const disabled = css`
  opacity: 0.4;
  pointer-events: none;
`;

/**
 * Disabled mixin for interactive elements (buttons, links, controls) that use
 * `aria-disabled="true"` instead of the HTML `disabled` attribute.
 *
 * Unlike `disabled`, this mixin intentionally omits `pointer-events: none` so
 * that click events still reach the element's JavaScript handler, where they
 * can be suppressed and optionally used to show feedback (e.g. a tooltip).
 *
 * Usage: pair with `aria-disabled="true"` on the element and an `onClick`
 * guard that returns early when the element is disabled.
 *
 * @see `disabled` for non-interactive elements
 * @deprecated Use `.seeds-interactive-disabled` in
 * `seeds-react-button/src/button.css` — the pure-CSS equivalent for
 * Tailwind-based components. This styled-components mixin has no remaining
 * consumers in the monorepo.
 */
export const interactiveDisabled = css`
  opacity: 0.4;
  cursor: not-allowed;
`;

export const container = css`
  background: ${({ theme }) => theme.colors.container.background.base};
  border: ${({ theme }) => theme.borders[500]}
    ${({ theme }) => theme.colors.container.border.base};
  border-radius: ${({ theme }) => theme.radii.outer};
`;

export const divider = css`
  border-bottom: ${({ theme }) => theme.borderWidths[500]} solid
    ${({ theme }) => theme.colors.container.border.base};
`;

export const truncate = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
